<template>
	<div class="chat-chat-ce">
		<div class="chat-chat-ce-title">
			<div class="chat-chat-ot-name"><span>{{chatUser.fans_wx_name}}</span>的客户信息</div>
			<div>
				<span class="chat-chat-ot-ding" @click="ding">{{positionMsg}}</span>
				<span class="chat-chat-ot-close" @click="closeTools">关闭</span>
			</div>
		</div>
		<div class="chat-chat-ce-box" v-if="position === 'center'">
			<div class="chat-chat-ce-wrap" v-if="showType === 1">
				<div class="chat-chat-ce-category">
					<fieldset id="">
						<legend>基本信息</legend>
						<div class="chat-chat-ce-items">
							<div class="chat-chat-ce-item">
								<label for="">客户：</label>
								<span>{{info.mobile}}</span>
							</div>
							<div class="chat-chat-ce-item">
								<label for="">A岗销售：</label>
								<span>{{info.managerA}}--{{info.identityA}}</span>
							</div>
							<div class="chat-chat-ce-item">
								<label for="">B岗销售：</label>
								<span>{{info.managerB}}--{{info.identityB}}</span>
							</div>
						</div>
						<div class="chat-chat-ce-items">
							<div class="chat-chat-ce-item">
								<label for="">昵称：</label>
								<input type="text" v-model="info.wx_name" disabled=""/>
							</div>
							<div class="chat-chat-ce-item">
								<label for="">备注：</label>
								<input type="text" v-model="info.con_remark" disabled=""/>
							</div>
							<div class="chat-chat-ce-item">
								<label for="">时间：</label>
								<input type="text" v-model="info.fans_time" disabled=""/>
							</div>
						</div>
						<div class="chat-chat-ce-items">
							<div class="chat-chat-ce-item">
								<label for="">姓名：</label>
								<input type="text" v-model="info.custom_name"/>
							</div>
							<div class="chat-chat-ce-item">
								<label for="">性别：</label>
								<select v-model="info.custom_sex">
									<option value ="1">男</option>
									<option value ="2">女</option>
								</select>
							</div>
							<div class="chat-chat-ce-item">
								<label for="">年龄区间：</label>
								<input type="text" v-model="info.age_range"/>
							</div>
						</div>
						<div class="chat-chat-ce-items">
							<div class="chat-chat-ce-item">
								<label for="">家庭情况：</label>
								<input type="text" v-model="info.family_info" class="chat-chat-ce-input-long"/>
							</div>
						</div>
						<div class="chat-chat-ce-items">
							<div class="chat-chat-ce-item">
								<label for="">收入情况：</label>
								<input type="text" v-model="info.income_info" class="chat-chat-ce-input-long"/>
							</div>
						</div>
						<div class="chat-chat-ce-items">
							<div class="chat-chat-ce-item">
								<label for="">身体情况：</label>
								<input type="text" v-model="info.health_info" class="chat-chat-ce-input-long"/>
							</div>
						</div>
						<div class="chat-chat-ce-items">
							<div class="chat-chat-ce-item">
								<label for="">其他信息：</label>
								<input type="text" v-model="info.other_info" class="chat-chat-ce-input-long"/>
							</div>
							<div class="chat-chat-ce-item">
								<button @click="autoCopy">一键复制</button>
							</div>
						</div>
					</fieldset>
				</div>
				<div class="chat-chat-ce-submit">
					<button @click="saveInfo">提交</button>
				</div>
			</div>
			<div class="chat-chat-ce-wrap" v-else-if="showType === 0 || showType === 2">
				<p class="chat-chat-ce-error">{{showMsg}}</p>
			</div>
			<div class="chat-chat-ce-wrap" v-else-if="3">
				<div class="chat-chat-ce-fans">
					<table class="layui-table">
					  <thead>
					    <tr>
							<th>昵称</th>
							<th>备注</th>
							<th>客户电话</th>
							<th>A岗管理员</th>
							<th>A岗客服</th>
							<th>客户录入时间</th>
							<th>操作</th>
					    </tr> 
					  </thead>
					  <tbody>
					    <tr v-for="fans in sameFans">
							<td>{{fans.wx_name}}</td>
							<td>{{fans.con_remark}}</td>
							<td>{{fans.mobile}}</td>
							<td>{{fans.manager_name}}</td>
							<td>{{fans.c_wx_name}}-{{fans.identity}}</td>
							<td>{{fans.create_time}}</td>
							<td><span @click="bindFans(fans.org_fans_id,fans.friend_mobile_id,fans)">绑定</span></td>
					    </tr>
					  </tbody>
					</table>
				</div>
			</div>
		</div>
		<div class="chat-chat-ce-box" v-else>
			<div class="chat-chat-ce-wrap" v-if="showType === 1">
				<div class="chat-chat-ce-category">
					<fieldset id="">
						<legend>基本信息</legend>
						<div class="chat-chat-ce-items">
							<div class="chat-chat-ce-item">
								<label for="">A岗销售：</label>
								<span>{{info.managerA}}--{{info.identityA}}</span>
							</div>
							<div class="chat-chat-ce-item">
								<label for="">B岗销售：</label>
								<span>{{info.managerB}}--{{info.identityB}}</span>
							</div>
						</div>
						<div class="chat-chat-ce-items">
							<div class="chat-chat-ce-item">
								<label for="">昵称：</label>
								<input type="text" v-model="info.wx_name" disabled=""/>
							</div>
							<div class="chat-chat-ce-item">
								<label for="">备注：</label>
								<input type="text" v-model="info.con_remark" disabled=""/>
							</div>
						</div>
						<div class="chat-chat-ce-items">
							<div class="chat-chat-ce-item">
								<label for="">姓名：</label>
								<input type="text" v-model="info.custom_name"/>
							</div>
							<div class="chat-chat-ce-item">
								<label for="">性别：</label>
								<select v-model="info.custom_sex">
									<option value ="1">男</option>
									<option value ="2">女</option>
								</select>
							</div>
						</div>
						<div class="chat-chat-ce-items">
							<div class="chat-chat-ce-item">
								<label for="">时间：</label>
								<input type="text" v-model="info.fans_time" disabled=""/>
							</div>
							<div class="chat-chat-ce-item">
								<label for="">年龄区间：</label>
								<input type="text" v-model="info.age_range"/>
							</div>
						</div>
						<div class="chat-chat-ce-items">
							<div class="chat-chat-ce-item">
								<label for="">家庭情况：</label>
								<input type="text" v-model="info.family_info" style="width: 200px;"/>
							</div>
						</div>
						<div class="chat-chat-ce-items">
							<div class="chat-chat-ce-item">
								<label for="">收入情况：</label>
								<input type="text" v-model="info.income_info" style="width: 200px;"/>
							</div>
						</div>
						<div class="chat-chat-ce-items">
							<div class="chat-chat-ce-item">
								<label for="">身体情况：</label>
								<input type="text" v-model="info.health_info" style="width: 200px;"/>
							</div>
						</div>
						<div class="chat-chat-ce-items">
							<div class="chat-chat-ce-item">
								<label for="">其他信息：</label>
								<input type="text" v-model="info.other_info" style="width: 200px;"/>
							</div>
							<div class="chat-chat-ce-item">
								<button @click="autoCopy">一键复制</button>
							</div>
						</div>
					</fieldset>
				</div>
				<div class="chat-chat-ce-submit">
					<button @click="saveInfo">提交</button>
				</div>
			</div>
			<div class="chat-chat-ce-wrap" v-else-if="showType === 0 || showType === 2">
				<p class="chat-chat-ce-error">{{showMsg}}</p>
			</div>
			<div class="chat-chat-ce-wrap" v-else-if="3">
				<div class="chat-chat-ce-fans">
					<table class="layui-table">
					  <thead>
					    <tr>
							<th>昵称</th>
							<th>备注</th>
							<th>客户电话</th>
							<th>A岗管理员</th>
							<th>A岗客服</th>
							<th>客户录入时间</th>
							<th>操作</th>
					    </tr> 
					  </thead>
					  <tbody>
					    <tr v-for="fans in sameFans">
							<td>{{fans.wx_name}}</td>
							<td>{{fans.con_remark}}</td>
							<td>{{fans.mobile}}</td>
							<td>{{fans.manager_name}}</td>
							<td>{{fans.c_wx_name}}-{{fans.identity}}</td>
							<td>{{fans.create_time}}</td>
							<td><span @click="bindFans(fans.org_fans_id,fans.friend_mobile_id,fans)">绑定</span></td>
					    </tr>
					  </tbody>
					</table>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {webGetExpansionByFansId,webSaveExpansion,webExpansionBind} from '../../network/web/auto-friend-mobile-expansion.js'
	
	export default{
		name:"ChatChatCustomerExpansion",
		props:{
			chatUser:{
				type: Object,
				default: function(){
					return {}
				}
			}
		},
		data(){
			return {
				info: {},
				showType: 0,
				showMsg : '数据请求中。。。',
				sameFans:[],
				position: 'center',
				positionMsg: '<---'
			}
		},
		methods:{
			// 关闭页面
			closeTools(){
				this.$emit('chat-customer-expansion-close')
			},
			
			// 查询已保存的客户信息
			getCustomInfo(){
				webGetExpansionByFansId(this.chatUser.fans_id,data=>{
					if(data.code == 1){
						let r_data = data.data
						this.showMsg = r_data.msg
						this.showType = r_data.showType
						this.info = r_data
						if(r_data.showType === 3){
							this.sameFans = r_data.sameFans
						}
					}
				})
			},
			
			// 添加宠物信息
			addPet(){
				let pet = {
					type: '',
					variety: '',
					name: '',
					birthday: '',
					sex: '1',
					weight: '',
					insect_time: '',
					vaccine: '',
					is_sterilization: '0',
					healthy: '',
					age: '',
					flavor: '',
					personality: '',
					other_info: ''
				}
				this.info.pets.push(pet)
			},
			
			// 删除宠物信息
			delPet(index){
				this.info.pets.splice(index,1)
			},
			
			// 添加交易信息
			addTransactionInfo(){
				let transaction_info = {
					name_number: '',
					money: '',
					time: ''
				}
				this.info.transaction_infos.push(transaction_info)
			},
			
			// 删除交易信息
			delTransactionInfo(index){
				this.info.transaction_infos.splice(index,1)
			},
			
			// 保存信息
			saveInfo(){
				webSaveExpansion({info:JSON.stringify(this.info)},data=>{
					if(data.code == 1){
						CHAT_LAYER.msg(data.msg,{icon: 1},()=>{
							this.closeTools()
						})
					}else{
						CHAT_LAYER.msg(data.msg,{icon: 2})
					}
				})
			},
			
			// 绑定粉丝到客户
			bindFans(fans_id,friend_mobile_id,fans){
				let _this = this
				CHAT_LAYER.confirm('确定绑定到：<span style="font-weight: 600">'+fans.manager_name+'-'+fans.c_wx_name+'-'+fans.identity+'</span>上吗？', {
					title: '绑定提示',
					btn: ['确定', '取消'] //可以无限个按钮
				}, function(index2, layero){
					CHAT_LAYER.close(index2)
					webExpansionBind({fans_id:fans_id,friend_mobile_id:friend_mobile_id},data=>{
						if(data.code == 1){
							CHAT_LAYER.msg(data.msg,{icon: 1},()=>{
								_this.getCustomInfo()
							})
						}else{
							CHAT_LAYER.msg(data.msg,{icon: 2})
						}
					})
				}, function(index2){
					//按钮【按钮二】的回调
				});
			},
			
			// 界面切换
			ding(){
				if(this.position === 'center'){
					this.position = 'left'
					this.positionMsg = '--->'
				}else{
					this.position = 'center'
					this.positionMsg = '<---'
				}
				this.$emit('chat-expansion-ding',this.position)
			},
			
			// 自动拷贝
			autoCopy(){
				const aux = document.createElement('textarea')
				aux.readOnly = 'readonly'
				aux.style.position = 'absolute'
				aux.style.left = '-9999px'
				let content = '昵称：' + this.info.wx_name + '\r\n'
				content += 'A号：' + this.info.identityA + '\r\n'
				content += 'B号：' + this.info.identityB
				aux.value = content
				document.body.appendChild(aux)
				aux.select()
				aux.setSelectionRange(0,aux.value.length)
				document.execCommand('copy')
				document.body.removeChild(aux)
				CHAT_LAYER.msg('复制成功！')
			},
			
			// autoCopy2(){
			// 	const aux = document.createElement('input')
			// 	let content = '昵称：' + this.info.wx_name + '\r\n'
			// 	content += 'A号：' + this.info.identityA + '\r\n'
			// 	content += 'B号：' + this.info.identityB
			// 	aux.setAttribute('value',content)
			// 	document.body.appendChild(aux)
			// 	aux.select()
			// 	document.execCommand('copy')
			// 	document.body.removeChild(aux)
			// 	CHAT_LAYER.msg('复制成功！')
			// }
		},
		created() {
			this.getCustomInfo()
		}
	}
</script>

<style>
	.chat-chat-ce{
		position: absolute;
		top: 100px;
		left: 20px;
		bottom: 100px;
		right: 20px;
		background-color: #FFFFFF;
		z-index: 11;
	}
	.chat-chat-ce-title{
		height: 32px;
		line-height: 32px;
		background-color: #e8e8e8;
		padding: 0 10px;
		display: flex;
		justify-content: space-between;
	}
	.chat-chat-ot-ding{
		font-size: 12px;
		color: #009688;
		cursor: pointer;
		user-select: none;
	}
	.chat-chat-ot-close{
		cursor: pointer;
		padding: 0 10px;
	}
	.chat-chat-ot-name span{
		font-weight: bold;
	}
	.chat-chat-ce-box{
		position: absolute;
		top: 40px;
		left: 0;
		right: 0;
		bottom: 10px;
		overflow: hidden;
	}
	.chat-chat-ce-box .chat-chat-ce-wrap{
		position: relative;
		height: 100%;
		padding: 0 10px;
		overflow-x: hidden;
		overflow-y: auto;
	}
	.chat-chat-ce-category{
		margin-bottom: 10px;
	}
	.chat-chat-ce-category input,.chat-chat-ce-category select{
		color: #666666;
	}
	.chat-chat-ce-block{
		border-bottom: 1px solid #CCCCCC;
	}
	.chat-chat-ce-block:last-child{
		border-bottom: none;
	}
	fieldset{
		border: 1px solid #CCCCCC;
		padding: 10px;
		border-radius: 2px;
	}
	legend{
		font-size: 16px;
		padding: 0 10px;
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
	.chat-chat-ce-add{
		display: block;
		width: 20px;
		height: 20px;
		background-image: url(../../assets/img/add-icon-2bad37-32.png);
		background-position: center;
		background-repeat: no-repeat;
		background-size: 18px auto;
		margin-left: 5px;
		cursor: pointer;
	}
	.chat-chat-ce-items{
		display: flex;
		justify-content: flex-start;
		align-items: center;
		flex-wrap: nowrap;
		font-size: 13px;
		padding: 10px 0;
		color: #666666;
	}
	.chat-chat-ce-item{
		display: flex;
		justify-content: flex-start;
		align-items: center;
		flex-wrap: nowrap;
		margin-right: 20px;
		color: #666666;
	}
	.chat-chat-ce-item-margin{
		margin: 10px 0;
	}
	.chat-chat-ce-item input{
		width: 140px;
		border-bottom: 1px solid #CCCCCC;
		padding: 2px 2px;
	}
	.chat-chat-ce-item span{
		display: block;
		width: 140px;
		border-bottom: 1px solid #CCCCCC;
		padding: 2px 2px;
	}
	.chat-chat-ce-item input:focus{
		border-bottom: 1px solid #009E94;
	}
	.chat-chat-ce-item select{
		width: 100px;
		border-bottom: 1px solid #CCCCCC;
	}
	.chat-chat-ce-item .chat-chat-ce-del{
		display: block;
		width: 20px;
		height: 20px;
		background-image: url(../../assets/img/delete-red-32.png);
		background-position: center;
		background-repeat: no-repeat;
		background-size: 16px auto;
		margin-left: 5px;
		cursor: pointer;
	}
	.chat-chat-ce-item button{
		padding: 2px 5px;
		border-radius: 2px;
		background-color: #009688;
		color: #FFFFFF;
		cursor: pointer;
	}
	.chat-chat-ce-input-long{
		width: 500px !important;
	}
	table input{
		height: 24px;
		line-height: 24px;
		padding: 0 5px;
		box-sizing: border-box;
		border-radius: 2px;
		width: 100%;
		border: 1px solid #FFFFFF;
	}
	table input:focus{
		border: 1px solid #009E94;
	}
	.chat-chat-ce-submit button{
		background-color: #009E94;
		width: 100px;
		height: 30px;
		line-height: 30px;
		border-radius: 2px;
		color: #FFFFFF;
		cursor: pointer;
	}
	.chat-chat-ce-error{
		line-height: 100px;
		text-align: center;
		color: #f47114;
	}
	.chat-chat-ce-fans{
		padding: 0 10px;
	}
	.chat-chat-ce-fans span{
		padding: 0 10px;
		height: 22px;
		line-height: 22px;
		background-color: #009688;
		color: #FFFFFF;
		display: inline-block;
		text-align: center;
		border-radius: 2px;
		cursor: pointer;
		user-select: none;
		font-size: 12px;
	}
</style>
